import React from 'react';
import './NavBar.css';

export default Navbar => {
    return (
        <header>
            <h1 className="logo">
                <div alt='logo'>HIVEMIND</div>
            </h1>
        </header>
    )
}